/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignStatusSchema = z.enum(['draft', 'review', 'publishing', 'active', 'completed'])

export type CampaignStatusSchema = z.infer<typeof campaignStatusSchema>
